
// import ExternalConfiguration from '../../external-configuration';

const Custom_4_player_Configuration = {

  processConfiguration: (loadedConfiguration = {}) => {
  
    return { custom_4_playerConfiguration: {}, contentData: {}, auxiliarData: {} };
  },

};

export default Custom_4_player_Configuration;
